import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Redirect, Link } from "react-router-dom";
import { userSignInWithEmailAndPassword } from "../../store/actions/authActions";
import Navbar from "../../components/layout/Navbar";

const Login = (props) => {
  // Hooks
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const [authError, setAuthError] = useState("");

  // Handle Sign up
  const handleSignIn = (e) => {
    e.preventDefault();
    setIsSubmitClicked(true);
    setAuthError(null);

    userSignInWithEmailAndPassword({
      email,
      password,
    });
  };

  // Handle Signin input
  const handleInput = (e) => {
    const { name, value } = e.currentTarget;
    switch (name) {
      case "email":
        setEmail(value);
        break;
      case "password":
        setPassword(value);
        break;
      default:
        break;
    }
  };

  const { userSignInWithEmailAndPassword, auth, existingUser } = props;
  useEffect(() => {
    if (auth.authError) {
      setAuthError(auth.authError);
      setIsSubmitClicked(false);
    }
  }, [auth]);

  if (existingUser) return <Redirect to="/dashboard" />;

  return (
    <>
      <Navbar />
      <section className="auth">
        <div className="auth__header">
          <h3 className="auth__header__heading">
            Log in to see what's{" "}
            <span className="auth__header__heading__span">happening</span>
          </h3>

          <div className="auth__form form">
            <form className="auth__form__container">
              <input
                type="email"
                name="email"
                className="form__input "
                placeholder="Your email"
                onChange={handleInput}
              />
              <input
                type="password"
                name="password"
                className="form__input "
                placeholder="Your Password"
                onChange={handleInput}
              />
              <button
                className="auth__form__submit btn btn-md"
                type="button"
                onClick={handleSignIn}
              >
                {!isSubmitClicked ? "Login" : "Logging in"}
              </button>
            </form>

            {authError ? (
              <h3 className="auth__form__error">{authError}</h3>
            ) : (
              ""
            )}

            <h3 className="auth__form__login__heading">Never joined?</h3>

            <Link to="/">
              <button className="btn btn-md auth__form__login__button">
                Register
              </button>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

const mapStateToProps = (state) => {
  const existingUser = localStorage.getItem("adminId");

  return {
    auth: state.auth,
    existingUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    userSignInWithEmailAndPassword: (payload) => {
      dispatch(userSignInWithEmailAndPassword(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
